import { useState, useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import FontOptions from '../../../../../../../../componentLibrary/FontSelect/FontOptions';

interface Arguments {
    hasFullStylingAccess: boolean;
    hasIntegrationCustomFontsAccess: boolean;
    customizationPrimaryFont: string;
    customizationSecondaryFont: string;
    customFonts: any[];
    hasCustomFontsAccess: boolean;
    isCustomFontsLoaded: boolean;
}

export const useFonts = ({
    hasFullStylingAccess,
    hasIntegrationCustomFontsAccess,
    customizationPrimaryFont,
    customizationSecondaryFont,
    customFonts,
    hasCustomFontsAccess,
    isCustomFontsLoaded,
}: Arguments) => {
    const [fontOptions, setfontOptions] = useState<FontOptions>();
    const [isCustomFontsInFontOptions, setIsCustomFontsInFontOptions] = useState(false);

    useEffect(() => {
        setfontOptions(
            new FontOptions({
                hasFullStylingAccess,
                hasIntegrationCustomFontsAccess,
                customizationPrimaryFont,
                customizationSecondaryFont,
                customFonts,
            })
        );
    }, [
        hasFullStylingAccess,
        hasIntegrationCustomFontsAccess,
        customizationPrimaryFont,
        customizationSecondaryFont,
        customFonts,
    ]);

    useEffect(() => {
        if (
            !isCustomFontsInFontOptions &&
            fontOptions &&
            hasCustomFontsAccess &&
            isCustomFontsLoaded &&
            !_isEmpty(customFonts)
        ) {
            setIsCustomFontsInFontOptions(true);
            fontOptions.setCustomFonts(customFonts);
        }
    }, [hasCustomFontsAccess, isCustomFontsLoaded, fontOptions, customFonts, isCustomFontsInFontOptions]);

    return { fontOptions };
};
